import i18n from '@/locales';

export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.use(i18n);
});
